// @mui
import { styled } from '@mui/material/styles';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Stack,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
// components
import Iconify from '../../../components/Iconify';


const IconStyle = styled(Iconify)(({ theme }) => ({
  width: 22,
  height: 22,
  flexShrink: 0,
  marginRight: theme.spacing(1),
}));


export default function PositionGuideDialog({ role, isOpen, closeDialog }) {
  if (!role || !role.length === 1) return <></>;
  return (
    <Dialog open={isOpen} onClose={closeDialog} fullWidth maxWidth="sm">
      <DialogTitle sx={{ mb: 2 }}>
        {role?.[0]?.role}
      </DialogTitle>
      <DialogContent>
        <Stack>
          <Stack direction="row" alignContent="center">
            <IconStyle icon={"ic:outline-check-circle"} sx={{ color: 'success.main' }} />
            <Typography variant="subtitle1" gutterBottom>
              이런 일을 합니다
            </Typography>
          </Stack>
          <Typography sx={{ whiteSpace: 'pre-wrap' }} paragraph>
            {role?.[0]?.can}
          </Typography>
        </Stack>
        {role?.[0]?.cant && (
          <Stack sx={{ mt: 1 }}>
            <Stack direction="row" alignContent="center">
              <IconStyle icon={"ic:outline-do-not-disturb-alt"} sx={{ color: 'error.main' }} />
              <Typography variant="subtitle1" gutterBottom>
                이런일은 할 수 없어요
              </Typography>
            </Stack>
            <Typography sx={{ mb: 2, whiteSpace: 'pre-wrap' }}>
              {role?.[0]?.cant}
            </Typography>
          </Stack>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={closeDialog}
        >
          확인했어요
        </Button>
      </DialogActions>
    </Dialog>
  )
}
